import React, { FC, useEffect, useState } from "react";
import "./mostDislikedContent.scss";
import DislikeIcon from "../../../assets/icons/dislike.svg";
import { Col, Row, Spin } from "antd";
import faker from "faker";
import AttemptsIcon from "../../../assets/icons/attempt.svg";
import PlayIcon from "../../../assets/icons/play.svg";
import PdfIcon from "../../../assets/icons/document.svg";
import ThumbUpIcon from "../../../assets/icons/thumb-up.svg";
import ThumbDownIcon from "../../../assets/icons/thumb-down.svg";
import DashboardFilter from "../DashboardFilter";
import { MostDislikedContentModel } from "../../../models/DashboardModel/MostDislikedContentModel/mostDislikedContent.model";
import DashboardService from "../../../services/DashboardService/dashboard.service";
import ContentPlaceholder from "../../../assets/placeholder/content-placeholder.svg";
import { serialize } from "serializr";
import { _DashboardFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/_dashboardFilter.model";
import { defaultFilter } from "../../../shared/utils/filter";

interface MostDislikedContentProps { }

const MostDislikedContent: FC<MostDislikedContentProps> = (props: any) => {
  const { user } = props;
  const [loading, setLoading] = useState(false);
  const [contents, setContents] = useState<MostDislikedContentModel[]>([]);
  const fetchMostDislikedContents = (params?: any) => {
    setLoading(true)
    const payload = serialize(_DashboardFilterModel, params ?? defaultFilter);
    DashboardService.fetchMostDislikedContent(
      payload,
      (contents) => {
        setContents(contents);
        setLoading(false);
      },
      () => {
        setLoading(false)
      },
      () => { }
    );
  };

  useEffect(() => {
    if (user?.roleName === 'admin')
      fetchMostDislikedContents();
  }, []);
  return (
    <div className="most-disliked-content">
      <div className="most-disliked-content__header-wrapper">
        <div className="most-disliked-content__header">
          <img src={DislikeIcon} />
          Most disliked content
        </div>
        <DashboardFilter
          applyHandler={(values) => fetchMostDislikedContents({ ...defaultFilter, ...values })}
          clearHandler={() => fetchMostDislikedContents()}
        />
      </div>

      <div className="most-disliked-content__wrapper">
        {loading ? (
          <Spin tip="Loading..." className="spin__loader" />
        ) : !contents?.length ? (
          <p className="no__data">No data!</p>
        ) : (
          contents?.map((value, index) => {
            return (
              <Row key={"#most-disliked_#" + index} className="most-disliked-content__card">
                <Col span={6}>
                  <img
                    className="most-disliked-content__thumbnail"
                    src={value?.contentThumbUrl ?? ContentPlaceholder}
                  />
                </Col>
                <Col span={18}>
                  <div className="most-disliked-content__card-right">
                    <p className="most-disliked-content__card-title">{value?.contentName}</p>
                    <Row>
                      <Col span={6}>
                        <div className="most-disliked-content__card-count attempt">
                          <img src={AttemptsIcon} /> {value?.attempts} attempts
                        </div>
                      </Col>
                      {/* {(value?.contentType == "video" ||
                        value?.contentType == "pdf") && (
                        <Col span={6}>
                          <div className="most-disliked-content__card-count pdf">
                            <img src={PdfIcon} /> {value?.contentLength}{" "}
                            {value?.contentType == "video" ? "mins" : "pages"}
                          </div>
                        </Col>
                      )} */}
                      <Col span={6}>
                        <div className="most-disliked-content__card-count pdf">
                          <img src={PdfIcon} /> {value?.contentLength}
                        </div>
                      </Col>
                      <Col span={6}>
                        <div className="most-disliked-content__card-count like">
                          <img src={ThumbUpIcon} /> {value?.likes}
                        </div>
                      </Col>
                      <Col span={6}>
                        <div className="most-disliked-content__card-count dislike">
                          <img src={ThumbDownIcon} /> {value?.dislikes}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            );
          })
        )}
      </div>
    </div>
  );
};

export default MostDislikedContent;
